module.exports = __webpack_public_path__ + "static/media/107.1daa7adc.jpg";